/// <amd-module name="Build/Admin/Pool/Stores/ElasticNodeStore" />
import { Store } from "VSS/Reflux/Store";

import { ElasticNode } from "DistributedTask/Client/Contracts/TaskAgent";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IElasticNodeStoreState {
    elasticNodes: ElasticNode[];
    status: StoreStatus;
}

export class ElasticNodeStore extends Store {
    public state: IElasticNodeStoreState = {
        elasticNodes: [],
        status: StoreStatus.None
    };

    constructor() {
        super("ElasticNodeStoreChanged");
    }

    public updateElasticNodes = (elasticNodes: ElasticNode[]): void => {
        this.state = {
            elasticNodes,
            status: StoreStatus.Loaded
        };
        this.emitChanged();
    }

    public updateElasticNode = (updatedElasticNode: ElasticNode): void => {
        const otherNodes: ElasticNode[] = this.state.elasticNodes.filter(elasticNode => elasticNode.id !== updatedElasticNode.id);
        otherNodes.push(updatedElasticNode);

        this.state = {
            ...this.state,
            elasticNodes: otherNodes
        };

        this.emitChanged();
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };
        this.emitChanged();
    }
}
